<template>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <!--分类名称-->
      <el-form-item label="角色名称" prop="role_name" :label-width="formLabelWidth">
        <el-input v-model="formData.role_name" autocomplete="off" placeholder="请输入角色名称"></el-input>
      </el-form-item>

      <!-- <el-form-item label="权限列表：" v-model="formData.category_id"> -->
        <el-tree :data="category" show-checkbox node-key="category_id" :default-expand-all="true" :default-checked-keys="[]" :props="defaultProps" @check="handleCheckChange"></el-tree>
      <!-- </el-form-item> -->
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import RoleApi from '@/api/study/role.js';
import { deepClone } from '@/utils/base.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        /*角色名称*/
        role_name: '',
        category_id: 0
      },
      /*验证规则*/
      formRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  props: {
    open_edit:Boolean,
    selectModel:Object,
    category:Array,
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.formData=deepClone(this.selectModel);
  },
  methods: {
    //监听选中
    handleCheckChange(data, checked) {
      this.formData.category_id = checked.checkedKeys.concat(checked.halfCheckedKeys);
    },
    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          RoleApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/role/part/Edit.vue